import type { HotkeysMapProps } from './components/HotkeysMap';
import type { CommandCategory } from './components/CommandCategory';
import type { HotkeyCommand } from 'owa-hotkeys';
import type * as lazyIndex from './lazyIndex';
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "HotkeysMap" */ './lazyIndex'),
    { name: 'HotkeysMap' }
);

export { default as setIsHotkeysMapVisible } from './actions/setIsHotkeysMapVisible';

export type { CommandCategory } from './components/CommandCategory';

export const lazyLaunchHotkeysMap: LazyAction<
    typeof lazyIndex.launchHotkeysMap,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.launchHotkeysMap);
export const lazyUpdateHotkeysMapStore: LazyAction<
    (
        commandCategories: CommandCategory[],
        hotkeyCommands: HotkeyCommand[],
        firstColumnLength?: number
    ) => void,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.updateHotkeysMapStore);

export const HotkeysMap: LazyComponent<HotkeysMapProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.HotkeysMap
);
